// Footer columns (mockup 9c): <details> groups stay open and non-interactive on desktop,
// and become collapsible accordions below 700px. Without JS every group stays open.
if (!customElements.get('footer-accordion')) {
  class FooterAccordion extends HTMLElement {
    connectedCallback() {
      this.mql = window.matchMedia('(max-width: 699px)');
      this.onChange = () => this.sync();
      this.onClick = (event) => {
        if (!this.mql.matches && event.target.closest('summary')) event.preventDefault();
      };
      this.onBlockSelect = (event) => {
        const group = event.target.closest?.('.pv-footer__group');
        if (group && this.contains(group)) group.open = true;
      };

      this.mql.addEventListener('change', this.onChange);
      this.addEventListener('click', this.onClick);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      this.sync();
    }

    disconnectedCallback() {
      this.mql?.removeEventListener('change', this.onChange);
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    sync() {
      const mobile = this.mql.matches;
      this.querySelectorAll('.pv-footer__group').forEach((group) => {
        group.open = !mobile;
        const summary = group.querySelector('summary');
        if (!summary) return;
        // On desktop the headings are plain labels, so keep them out of the tab order.
        if (mobile) summary.removeAttribute('tabindex');
        else summary.setAttribute('tabindex', '-1');
      });
    }
  }

  customElements.define('footer-accordion', FooterAccordion);
}
